const Switcher = {

  init: function() {
    Switcher.start_timer();

    $('.news-item').mouseenter(function() {
      let news_id = $(this).attr('data-news-id');
      Switcher.stop_timer();
      if(typeof news_id != 'undefined') {
        Switcher.slide_switch(news_id);
      }
    }).mouseleave(function() {
      Switcher.start_timer();
    });
  },

  start_timer: function() {
    this.news_timer = setInterval( function () {
      Switcher.slide_switch()
    }, 5000 );
  },

  stop_timer: function() {
    clearInterval(this.news_timer);
  },

  slide_switch: function(radio) {
    let $active = $('#main-news div.active');
    let $active_radio = $('#other-news .news-item.active');

    if ( $active.length == 0 ) $active = $('#main-news div:last');
    if ( $active_radio.length == 0 ) $active_radio = $('#other-news .news-item:last');

    let $next =  $active.next().length ? $active.next()
      : $('#main-news div:first');

    let $next_radio =  $active_radio.next().length ? $active_radio.next()
      : $('#other-news .news-item:first');

    $active.addClass('last-active');

    if(typeof radio !== "undefined") {
      $next = $('#main-news div.news-' + radio);
      $next_radio = $('#other-news .news-item.news-' + radio);

      if(!$next.hasClass('active')) {
        $active_radio.removeClass('active');
        $next_radio.addClass('active');

        $next.show()
          .css({opacity: 1.0})
          .addClass('active');

        $active.hide()
          .css({opacity: 0.0})
          .removeClass('active')
          .removeClass('last-active');
      }

    }
    else {
      $next.show();

      $active_radio.removeClass('active');
      $next_radio.addClass('active');

      $next.css({opacity: 0.0})
        .addClass('active')
        .animate({opacity: 1.0}, 2000, function() {

        });

      $active.css({opacity: 1.0})
        .removeClass('active')
        .animate({opacity: 0.0}, 2000, function() {
          $active.removeClass('last-active');
          $active.hide();
        });
    }
  }

};

export default Switcher;